import { Component } from '@angular/core';
import { ServicesService } from 'src/services/services.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';

@Component({
  selector: 'app-addlisting',
  templateUrl: './addlisting.component.html',
  styleUrls: ['./addlisting.component.scss'],
  standalone: false
})
export class AddlistingComponent {
  message!: string;
  logofileURL!: string | ArrayBuffer | null;
  logoPath: any;
  isOld1 = false;
  imagefileURL!: any | ArrayBuffer;
  imgType!: any | ArrayBuffer;
  imagePath: any;

  public model = {
    editorData: ''
  };

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Write Description....',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      }
    ],
    uploadUrl: 'v1/image',
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['bold', 'italic'],
      ['fontSize']
    ]
  };
  event_name: any;
  event_type: any;
  description: any;
  address: any;
  from_date: any;
  to_date: any;
  event_logo: any;
  event_image: any;
  from_time: any;
  to_time: any;
  type: any;
  is_active: any;
  user_id: any;
  total_reg: any;
  reg_fee: any;
  event_result: any;
  organizer: any;
  company_pan: any;

  constructor(
    private service: ServicesService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private location: Location,
    private router: Router
  ) {
    this.user_id = sessionStorage.getItem('User_ID');
  }

  ngOnInit() {
    this.getType();
  }

  previewplogo(files: any) {
    if (files.length === 0) {
      return;
    }
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = 'Only images are supported.';
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.logofileURL = reader.result;
      this.imgType = 'event_logo';
      this.service.uploadimage(this.logofileURL, this.imgType).subscribe((data: any) => {
        this.logoPath = data['image_name'];
      });

    };
  }


  previewpimage(files: any) {
    if (files.length === 0) {
      return;
    }
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = 'Only images are supported.';
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imagefileURL = reader.result;
      this.imgType = 'event_image';
      this.service.uploadimage(this.imagefileURL, this.imgType).subscribe((data: any) => {
        this.imagePath = data['image_name'];
      });
    };
  }

  getType() {
    this.service.get_eventtype().subscribe(
      (data: any) => {
        this.event_result = data.data;
      }
    );
  }

  Add_Event() {
    const Event_Data = {
      user_id: this.user_id,
      event_name: this.event_name,
      event_type: this.event_type,
      description: this.description,
      address: this.address,
      organizer: this.organizer,
      company_pan: this.company_pan,
      reg_fee: this.reg_fee,
      from_date: this.from_date,
      to_date: this.to_date,
      event_logo: this.logoPath,
      event_image: this.imagePath,
      from_time: this.from_time,
      to_time: this.to_time,
      total_reg: this.total_reg,
      type: this.type,
      is_active: 0,
    }
    this.service.add_Event(Event_Data).subscribe(
      (data: any) => {
        if (data.flag == true) {
          this.toastr.success(data.msg);
          this.router.navigate(['/admin/Listings']);
        } else if (data.flag == false) {
          this.toastr.error(data.msg);
        }
      });
  }

  Cancel() {
    this.location.back();
  }

}

